interface BilingualText {
  en: string;
  fr: string;
}

interface ErrorMessages {
  [key: string]: BilingualText;
}

const errorLang: ErrorMessages = {
  email: {
    en: 'Please check the email address format. ',
    fr: 'Veuillez vérifier le format de l\'adresse courriel. '
  },
  name: {
    en: 'There are some unusual characters in your entry. This field accepts only letters, hyphens(-) or apostrophes(\').',
    fr: "Votre saisie comprend des caractères inhabituels. Ce champ n'accepte que des lettres, des tirets (-) ou des apostrophes (')"
  },
  isAlphaNumeric: {
    en: 'There are some unusual characters in your entry. This field accepts only letters and numbers.',
    fr: 'Il y a des caractères inhabituels dans votre entrée. Ce champ n\'accepte que des lettres et des chiffres.',
  },
  postalcode: {
    en: 'Please check the postal code format. ',
    fr: 'Veuillez vérifier le format de l\'adresse courriel.'
  },
  phone: {
    en: "Please enter in a valid phone number.",
    fr: "Veuillez saisir un numéro de téléphone valide."
  },
  required: {
    en: 'This is a required field.',
    fr: 'Ce champ est obligatoire.'
  },
  preferredContact: {
    en: 'This is a required field.',
    fr: 'Ce champ est obligatoire.'
  },
  subject: {
    en: 'In order to help us deal with your query quickly, we need a subject for your email.',
    fr: 'Afin de nous aider à traiter rapidement votre demande, nous avons besoin d\'un sujet pour votre courriel.'
  },
  vin: {
    en: 'The Vehicle Identification Number (VIN) you have entered is not valid.',
    fr: 'Le numéro d\'identification de véhicule que vous avez entré n\'est pas valide.'
  },
  mb20: {
    en: 'Error: File over 20mb',
    fr: 'Erreur : Fichier de plus de 20 Mo'
  },
  odometer: {
    en: 'The odometer value you have entered must be a number.',
    fr: 'La valeur saisie pour l\'odomètre doit être un nombre.'
  },
  nameMaxMin: {
    en: 'Please enter a name between 2 and 50 characters.',
    fr: 'Veuillez entrer un nom comprenant entre 2 et 50 caractères.'
  },
  general: {
    en: 'An unexpected error has occurred. Please refresh the page and try again. We apologize for the inconvenience.',
    fr: 'Une erreur inattendue s\'est produite. Veuillez actualiser la page et réessayer. Nous nous excusons pour cet inconvénient.'
  },
  positive: {
    en: 'Please enter a positive number.',
    fr: 'Veuillez saisir un nombre positif.'
  },
};

export default errorLang;
